import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ProductGroupDto } from './product-group.dto';

import { PageQueriesModel } from './../shared/page-queries.model';
import { PageDto } from './../shared/page.dto';

@Injectable()
export class ProductGroupRestService {
  private productManagementUrl = 'api/productManagement';
  constructor(private httpClient: HttpClient) {}

  getList(queries: PageQueriesModel) {
    const url = `${this.productManagementUrl}/productgroups`;
    const options = {
      params: queries.getParams()
    };

    return this.httpClient.get<PageDto<ProductGroupDto>>(url, options).pipe(
      map(d => {
        const page = new PageDto(d);
        page.content = d.content.map(i => new ProductGroupDto(i));
        return page;
      })
    );
  }

  get(id: string): Observable<ProductGroupDto> {
    const url = `${this.productManagementUrl}/productgroups/${id}`;

    return this.httpClient
      .get<ProductGroupDto>(url)
      .pipe(map(d => new ProductGroupDto(d)));
  }

  post(
    productGroup: ProductGroupDto,
    clientId: string
  ): Observable<ProductGroupDto> {
    const url = `${
      this.productManagementUrl
    }/clients/${clientId}/productgroups`;

    return this.httpClient
      .post<ProductGroupDto>(url, productGroup)
      .pipe(map(d => new ProductGroupDto(d)));
  }

  put(productGroup: ProductGroupDto): Observable<ProductGroupDto> {
    const productGroupId = productGroup.identity.id;
    const clientId = productGroup.entity.parent.id;
    const url = `${
      this.productManagementUrl
    }/clients/${clientId}/productgroups/${productGroupId}`;

    return this.httpClient
      .put<ProductGroupDto>(url, productGroup)
      .pipe(map(d => new ProductGroupDto(d)));
  }

  delete(productGroup: ProductGroupDto) {
    const clientId = productGroup.entity.parent.id;
    const productGroupId = productGroup.identity.id;
    const url = `${
      this.productManagementUrl
    }/clients/${clientId}/productgroups/${productGroupId}`;

    return this.httpClient.delete(url);
  }
}
